<template>
  <div class="w-full bg-[#191919] h-[53px] z-[10030]">
    <div
      class="w-full px-3 md:px-5 py-[10px] flex items-center justify-between sticky mx-auto"
      :class="sidebarOpen ? 'max-w-[1920px]' : 'max-w-full'"
    >
      <div class="flex gap-4">
        <button @click="toggleSidebar" class="inline-block">
          <Bars3Icon class="size-6 text-white" />
        </button>
        <ChartBarSquareIcon class="size-6 text-white hidden md:inline-block" />
        <h1 class="heading text-white text-xl mb-0 font-semibold">Dashboard</h1>
      </div>
      <div
        class="border-[1px] border-[#4C4C4C] bg-[#2B2B2B] w-[40%] px-2 rounded-[22.5px] py-2 gap-[12px] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] hidden lg:flex"
      >
        <MagnifyingGlassIcon class="size-6 text-white inline-block" />
        <input
          type="text"
          disabled
          readonly
          placeholder="Search here..."
          class="w-full bg-transparent focus-within:outline-none focus:outline-none text-white placeholder:text-[#4C4C4C]"
        />
      </div>
      <div class="flex items-center gap-3">
        <h1 class="heading text-white text-base mb-0 hidden md:flex">Hey, {{ user?.name }}</h1>
        <img :src="Avatar" alt="AVATAR" class="rounded-full size-10 hidden md:flex" />
        <!-- <button
          class="focus:outline-none focus-visible:outline-none size-10 rounded-full bg-[#FFFFFF0D] justify-center items-center notification-button relative hidden md:flex"
        >
          <BellIcon class="size-6 text-white inline-block" />
          <span class="size-3 text-[#DF0404] absolute top-[10px] right-[10px]"></span>
        </button> -->
        <button
          class="focus:outline-none focus-visible:outline-none size-10 rounded-full cursor-pointer hover:bg-[#FFFFFF0D] flex justify-center items-center duration-100 relative dropdown-icon"
          @click="toggleDropdown"
          @blur="toggleDropdown"
          ref="dopdownToggler"
        >
          <EllipsisVerticalIcon class="size-6 text-white inline-block" />

          <div class="dropdown-menu" v-if="dropdownOpen">
            <div class="dropdown-header hidden md:block">Quick Access</div>
            <div class="dropdown-header flex md:hidden items-center gap-2 justify-center">
              <img :src="Avatar" alt="AVATAR" class="rounded-full size-5" />
              Hey, {{ user?.name }}
            </div>
            <ul class="dropdown-list">
              <li
                class="dropdown-item px-5 py-2 mb-0 text-[16px] whitespace-nowrap bg-white text-left"
                @click="
                  openV2Application({
                    name: 'General Settings',
                    to: '/general-settings',
                  })
                "
              >
                <Cog8ToothIcon class="size-5 text-[#009FE3] inline-block mr-2" />
                Settings
              </li>
              <li
                class="dropdown-item px-5 py-2 mb-0 text-[16px] whitespace-nowrap bg-white text-left"
                @click="store.logout"
              >
                <ArrowLeftStartOnRectangleIcon class="size-5 text-[#009FE3] inline-block mr-2" />
                Logout
              </li>
            </ul>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import Avatar from '@/assets/img/avatars/custimoo-logo.png';
import { openV2Application } from '@/composables';
import { useMainStore } from '@/store';
import {
  ArrowLeftStartOnRectangleIcon,
  Bars3Icon,
  BellIcon,
  ChartBarSquareIcon,
  Cog8ToothIcon,
  EllipsisVerticalIcon,
  MagnifyingGlassIcon,
} from '@heroicons/vue/24/solid';
import { onClickOutside } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import { ref } from 'vue';

const { user, sidebarOpen } = storeToRefs(useMainStore());
const store = useMainStore();
const dropdownOpen = ref<boolean>(false);
const dopdownToggler = ref<HTMLElement | null>(null);
const toggleDropdown = (): void => {
  dropdownOpen.value = !dropdownOpen.value;
};
const toggleSidebar = (): void => {
  sidebarOpen.value = !sidebarOpen.value;
};
onClickOutside(dopdownToggler, () => {
  dropdownOpen.value = false;
});
</script>
<style lang="scss">
.dropdown-menu {
  position: absolute;
  top: 80%;
  right: 0;
  width: 200px;
  height: auto;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

  .dropdown-header {
    background-color: #ebedef !important;
    padding: 0.5rem 1.25rem;
    margin-bottom: 0;
    font-size: 0.765625rem;
    white-space: nowrap;
    color: #8a93a2;
  }

  .dropdown-list {
    .dropdown-item {
      &:not(:last-of-type) {
        border-bottom: 1px solid #ebedef;
      }

      &:hover {
        background-color: #ebedef;
      }
    }
  }
}
</style>
